<template>
  <div>
    <div class="">
      <div class="h-36rem w-36rem object-cover">
        <img :src="main_img" alt="" :onerror="defaultUrl" />
      </div>
      <div class="flex flex-row mt-3 w-34rem small flex-wrap">
        <img
          v-for="(img, i) in imgs_list"
          :key="i"
          class="!w-5rem !h-5rem mb-3 mr-3 img"
          :class="{ ring: main_img === img }"
          @click="select"
          :src="img"
          alt=""
          :onerror="defaultUrl"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";

export default {
  props: { imgs: String },
  setup(props) {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';
    const imgs_list = props.imgs.split(";");
    const main_img = ref(imgs_list[0]);

    const select = (e) => {
      main_img.value = e.target.src;
    };
    return { select, main_img, imgs_list, defaultUrl };
  },
};
</script>

<style scoped lang="scss">.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(21, 186, 99, var(--tw-ring-opacity));
}
img {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(229, 231, 235, var(--tw-ring-opacity));
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  cursor: pointer;
}
@media (min-width: 640px) {
  img {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  img {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  img {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  img {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  img {
    max-width: 1536px;
  }
}</style>
